import { Injectable } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CrudHelper } from '../../../firebase/helpers/crudHelper';
import { CommonService } from '../../../shared/component-store/common-service';
import { AuthService } from 'src/app/firebase/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ServicesService extends CommonService {
  isOpenForm = new BehaviorSubject(false);
  userId;

  constructor(
    private fb: FormBuilder,
    private firebaseHelperService: CrudHelper,
    private authService: AuthService
  ) {
    super(firebaseHelperService);
  }

  addImage(images) {
    let i = images.length;
    i = this.fb.group({
      image: [null],
    });
    images.push(i);
  }

  deleteImage(images: FormArray, i: number) {
    images.removeAt(i);
  }

  getProfile(email: string) {
    return this.firebaseHelperService.searchByField('users', 'email', email);
  }

  getItems({ collectionName, filter }) {
    // Special handling for admin approval panel
    if (window.location.pathname.includes('/approvement')) {
      const queryFn = ref => {
        let query = ref;
        query = query.where('status', '==', 'pending');
        query = query.orderBy('createdAt', 'desc');
        return query;
      };

      const result = this.firebaseHelperService.getCollectionItems({
        collectionName,
        queryFn,
      });

      // Add logging for debugging
      result.subscribe(
        items => {
          console.log(
            `[Approval Panel] ${collectionName} items fetched:`,
            items?.length || 0
          );
          console.log(`[Approval Panel] ${collectionName} items:`, items);
        },
        error => {
          console.error(
            `[Approval Panel] Error fetching ${collectionName}:`,
            error
          );
        }
      );

      return result;
    }

    // Regular view handling (non-admin panel)
    if (!filter || filter === false) {
      filter = { status: 'approved' };
    }

    const queryFn = ref => {
      let query = ref;

      const { location, type, creator, status, myContent } = filter || {}; // Add fallback empty object

      if (type && type.length > 0) {
        query = query.where('type', 'in', type);
      }

      if (location && location.length) {
        query = query.where('location.country.region', 'in', location);
      }

      if (creator || myContent) {
        const user = creator || this.authService.isUserAuth().uid;
        query = query.where('creator.id', '==', user);
        query = query.where('status', 'in', [
          'approved',
          'pending',
          'rejected',
          'pending-repeat',
        ]);
      }

      if (status) {
        query = query.where('status', '==', status);
      }

      // Only add the default status filter if we don't have any other status filters
      if (!status && !creator && !myContent) {
        query = query.where('status', '==', 'approved');
      }

      query = query.orderBy('createdAt', 'desc');

      return query;
    };

    return this.firebaseHelperService.getCollectionItems({
      collectionName,
      queryFn,
    });
  }

  getMyItems(collectionName, creator) {
    const queryFn = ref => {
      let query = ref;

      query = query.where('creator.id', '==', creator);

      return query;
    };

    return this.firebaseHelperService.getCollectionItems({
      collectionName,
      queryFn,
    });
  }

  checkFilter(filter) {
    // If filter is false or undefined, show all items
    if (!filter || filter === false) {
      return true;
    }

    // Check if any filter is actively set
    const hasActiveFilter =
      (filter.country && filter.country.length > 0) ||
      filter.dogsAllowed === true ||
      filter.naturePools === true ||
      filter.finsAllowed === true ||
      filter.freeEntry === true ||
      filter.myContent === true;

    return hasActiveFilter;
  }

  formatStartDate(date) {
    const startDate = date?.completionDate.startDate;
    if (startDate?.seconds && startDate?.seconds !== 0) {
      return new Date(startDate.seconds * 1000);
    }
    return null;
  }

  formatEndDate(date) {
    const endDate = date?.completionDate.endDate;
    if (endDate?.seconds && endDate?.seconds !== 0) {
      return new Date(endDate.seconds * 1000);
    }
    return null;
  }
}

